/**
 * Сервис атворизации
 */
export default class AuthService {
	// Ключ в локальном хранилище для хранения данных о пользователе
	static STORAGE_KEY_USER = "user"

	/**
	 * Инициализировать сервис
	 * @param {Object} authClient
	 * @param {Object} httpClient
	 * @param {Object} errorHandler
	 */
	constructor(authClient, httpClient, errorHandler) {
		this.authClient = authClient
		this.httpClient = httpClient
		this.errorHandler = errorHandler
		this.handlers = []

		// Слушать изменения токена и реагировать на них повторной авторизацией
		this.authClient.onChangeToken(() => this.auth())
	}

	/**
	 * Установить обработчика статуса авторизации
	 * @param {Function} handler
	 */
	onAuth(handler) {
		this.handlers.push(handler)
	}

	/**
	 * Получить текущего пользователя
	 */
	getUser() {
		return this.authClient.getUser()
	}

	/**
	 * Авторизовать пользователя
	 */
	async auth() {
		// Получить актуальный токен
		const token = this.authClient.getToken()

		try {
			// Проверить доступ к API (косвенная проверка статуса авторизации на бэке)
			const user = await this.getProfile(token)

			// Установить пользователя
			this.authClient.setUser(user)
		} catch {
			// Очистить информацию о пользователе
			this.authClient.unsetUser()
		}

		// Вызвать обработчики
		for (const handler of this.handlers) {
			await handler.call(null, this)
		}
	}

	/**
	 * Залогинить пользователя
	 * @param {String} email
	 * @param {String} password
	 * @return {Object}
	 */
	async login(email, password) {
		try {
			const user = await this.httpClient.post("login", { email, password })

			// Установить пользователя
			this.authClient.setUser(user)

			return user
		} catch (error) {
			throw this.errorHandler.parse(error)
		}
	}

	/**
	 * Разлогинить пользователя
	 */
	async logout() {
		try {
			await this.httpClient.post("logout")

			this.authClient.unsetUser()
		} catch (error) {
			throw this.errorHandler.parse(error)
		}
	}

	/**
	 * Получить профиль пользователя
	 * @param {String} token
	 */
	async getProfile(token) {
		try {
			const user = await this.httpClient.get("profile", { token })

			return { ...user, token }
		} catch (error) {
			// throw this.errorHandler.handle(error).parse()
		}
	}
}
